/** Fallback for the global JIT freshness window when BOT_SEQUENCE_JIT_FRESHNESS_MINUTES is unset. */
export const BOT_SEQUENCE_JIT_DEFAULT_FRESHNESS_MINUTES = 15;

/**
 * The global Sequence JIT freshness window in minutes — the single source for server and
 * bull. Reads BOT_SEQUENCE_JIT_FRESHNESS_MINUTES (positive integer) and falls back to the
 * 15-minute default. Per org/group/location overrides live with the Sequence Config table
 * (ENG-2987) once it lands; until then this global value is the effective window everywhere.
 */
export function getBotSequenceJitFreshnessMinutes(): number {
  const raw = typeof process !== "undefined" && process.env ? process.env["BOT_SEQUENCE_JIT_FRESHNESS_MINUTES"] : undefined;
  const parsed = raw ? parseInt(raw, 10) : NaN;
  return Number.isInteger(parsed) && parsed > 0 ? parsed : BOT_SEQUENCE_JIT_DEFAULT_FRESHNESS_MINUTES;
}
